import { render } from "./forum.vue?vue&type=template&id=6b35df49&ts=true"
import script from "./forum.vue?vue&type=script&lang=ts"
export * from "./forum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__